import { getDeviceType } from "../../services/commonService";

export const addAgencyFormState = {
    agency_name: '',
    agency_code: '',
    agency_type: 'external',
    agency_category: 'partner',
    agency_poc: '',
    agency_phone_number: '',
    agency_license: '',
    country_id: null,
    status: true,
}
export const addPromotionFormState = {
    promo_name: '',
    worker_type: [],
    worker_reference_id: [],
    branch_id: [],
    promo_value: '',
    start_date: new Date(),
    end_date: new Date(),
    isInfinite: false,
    promo_value_type: '',
}
export const partnerSendRegistrationFormState = {
    surname: '',
    name: '',
    email: '',
    branch_id: '',
};
export const clinicFormState = {
    clinic_name: '',
    agency_id: '',
    country_id: '',
    clinic_map_link: '',
    clinic_address: '',
    clinic_email: '',
}
export const addWorkerPromotionFormState = {
    agency_id: '',
    interview_mode: '',
    start_date: new Date(),
    end_date: new Date(),
    workerPromotionItemModel: [{ item: '', description: '' }],
    isInfinite: false,
};
export const addAgencyBranchFormState = {
    addAgencyFormState,
    branch_data: [
        {
            branch_name: '',
            branch_display_name_en: '',
            branch_display_name_in: '',
            branch_display_name_zh_CN: '',
            branch_code: '',
            branch_poc: '',
            branch_phone_number: '',
            branch_email: '',
            branch_address: '',
            branch_provinces: null,
            branch_time_zone: '',
            // branch_postal_code: '',
            branch_country_code: null,
            branch_google_map_link: '',
            off_days: [],
            sunday_branch_operating_start_time: '',
            sunday_branch_operating_end_time: '',
            monday_branch_operating_start_time: '',
            monday_branch_operating_end_time: '',
            tuesday_branch_operating_start_time: '',
            tuesday_branch_operating_end_time: '',
            wednesday_branch_operating_start_time: '',
            wednesday_branch_operating_end_time: '',
            thursday_branch_operating_start_time: '',
            thursday_branch_operating_end_time: '',
            friday_branch_operating_start_time: '',
            friday_branch_operating_end_time: '',
            saturday_branch_operating_start_time: '',
            saturday_branch_operating_end_time: '',
        }
    ],
};
export const addBranchFormState = {
    agency_id: '',
    branch_name: '',
    branch_display_name_en: '',
    branch_display_name_in: '',
    branch_display_name_zh_CN: '',
    branch_code: '',
    branch_poc: '',
    branch_phone_number: '',
    branch_email: '',
    branch_address: '',
    branch_provinces: '',
    branch_time_zone: '',
    // branch_postal_code: '',
    branch_country_code: '',
    branch_google_map_link: '',
    status: true,
    off_days: [],
    sunday_branch_operating_start_time: '',
    sunday_branch_operating_end_time: '',
    monday_branch_operating_start_time: '',
    monday_branch_operating_end_time: '',
    tuesday_branch_operating_start_time: '',
    tuesday_branch_operating_end_time: '',
    wednesday_branch_operating_start_time: '',
    wednesday_branch_operating_end_time: '',
    thursday_branch_operating_start_time: '',
    thursday_branch_operating_end_time: '',
    friday_branch_operating_start_time: '',
    friday_branch_operating_end_time: '',
    saturday_branch_operating_start_time: '',
    saturday_branch_operating_end_time: '',
};
export const addRoleFormState = {
    role_name: '',
    status: true,
}
export const addTemplateFormState = {
    module_key: "",
    category_id: "",
    language_id: "",
    template_name: "",
    dynamic_field_key: "",
    accessibility: "",
    template_content: "",
}

export const sendTemplateFormState = {
    module_key: "",
    category_id: "",
    language_id: "",
    template_name: "",
    channel: "",
    template_content: "",
    send_to: "",
}
export const leavePOlicyInitialFormState = {
    leaveType: "",
    accrualType: "",
    accrualRate: "",
    carryForwardMax: "",
    carryForwardType: "Percentage",
    encashMax: "",
    minThresholdToEncash: "",
    expiryInDays: "",
    effectiveFromDateOfHire: "",
    carryForwardable: "yes",
    encashable: "yes",
    expiry: "yes",
}
export const addUserDetailFormState = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    date_of_joining: '',
    role_id: '',
    whatsapp_country_code_name: '',
    // worker_staff_assign: [],
    // contract_staff_assign: [],
    spoken_languages: [],
    manager_id: '',
    password: '',
    personal_email: '',
    personal_phone: '',
    whatsapp: '',
    telephone: '',
    skype: '',
    facebook: '',
    airtable: '',
    bank_name: '',
    bank_account_number: '',
    bank_account_name: '',
    bank_branch_code: '',
    bank_hkid_copy: '',
    bank_employment_contract: '',
    salary_amount: '',
    salary_mpf_contri_type: '',
    salary_mpf_contri_amount: '',
    salary_mpf_contri_rate: '',
    overtime_pay: '0',
    doop_id: '',
    leave_policy_id: '',
    holiday_list_id: '',
    // contract_assign_type: '',
    // employer_assign_type: '',
    // worker_assign_type: '',
    // is_assign_employer: false,
    // is_assign_contract: false,
    // is_assign_worker: false,
    status: true,
    multifactor_email_authentication: false,
    staff_type: 'partner',
    staff_country_id: '',
    staff_agency_id: '',
    staff_branch_id: '',
    is_cs: 0,
    is_interpreter: 0,
    is_onboarding1: 0,
    is_onboarding2: 0,
    is_post_hire_interpreter: 0,
}
export const addHolidayFormState = {
    list_name: "",
    status: 1,
    holidays_data: [
        {
            holiday_name: "",
            holiday_date: null,
        },
    ],
}
export const addDoopFormState = {
    doop_name: '',
    status: true,
    off_days: [],
}
export const addAddressFormState = {
    type: '',
    address_line_1: '',
    address_line_2: '',
}

export const addCurrentWorkerFormState = {
    worker_name: '',
    employer_name: '',
    hk_id: '',
    staying_till_date_in_hk: '',
};

export const addShiftCodeFormState = {
    shift_code_data: [
        {
            shift_code: "",
            shift_time: ""
        }
    ]
}
export const addLeaveFormState = {
    leave_policy_details_id: "",
    from_date: "",
    to_date: "",
    from_date_type: "",
    to_date_type: "",
    comment: ""
}
export const timeRequestFormState = {
    date: null,
    durationHours: 1,
    durationMinutes: 1,
    comment: '',
    attachment: null,
};

export const timeRequestActionFormState = {
    time_approved_hours: 1,
    time_approved_minutes: 1,
    admin_comment: ''
};

export const managerApprovedTimeEntryFormState = {
    user_id: "",
    from_date: null,
    from_time: null,
    to_time: null,
    hours: null,
    minutes: null,
    comment: "",
};

export const manualUpdateLeaveFormState = {
    method: '',
    leave_policy_details_id: '',
    user_id: '',
    leave_count: '',
};

export const profileUpdate = {
    mobile_number: 0,
    HKID: '',
    birth_date: '',
    address1: '',
    emergency_contact_name: '',
    emergency_contact_relationship: '',
    emergency_contact_phone: '',
    whatsapp: '',
    telephone: '',
    personal_email: '',
    skype: '',
    facebook: '',
    instagram: '',
    airtable: '',
    bank_name: '',
    bank_account_number: '',
    bank_account_name: '',
    bank_branch_code: '',
    bank_remarks: '',
    bank_copy: '',
    bank_employment_contract: '',
};
export const empBasicDetailFormState = {
    title: "",
    surname: "",
    name: "",
    chinese_name: "",
    gender: "",
    birth_date: "",
    hk_id: "",
    nationality: "",
    spoken_language: "",
}
export const addressDetailFormState = {
    primary_residential_address: {
        address_line_1: ""
    },
    primary_correspondence_address: {
        address_line_1: ""
    },
    nationality_info: {
        name: ""
    },
    district_info: {
        name: ""
    },
    isSameAsResidential: false
};
export const currentWorkerFormState = {
    workers: [
        {
            worker_name: "",
            employer_name: "",
            hk_id: "",
            staying_till_date_in_hk: "",
        }
    ]
};
export const addEmployerFormState = {
    device_type: 1,
    title: "",
    name: "",
    surname: "",
    chinese_name: "",
    country_code: "",
    mobile_number: "",
    whatsapp_country_code: "",
    whatsapp_number: "",
    email: "",
    spoken_language: "",
    nationality: "",
    district: "",
    branch_id: '',
    cs_owner_id: "",
    whatsapp_confirmed: false,
}

export const addEmployerOfInvoiceFormState = {
    device_type: 1,
    title: "",
    name: "",
    surname: "",
    chinese_name: "",
    country_code: "",
    mobile_number: "",
    whatsapp_country_code: "",
    whatsapp_number: "",
    email: "",
    spoken_language: "",
    nationality: "",
    district: "",
    branch_id: '',
    birth_date: "",
    correspondence_address: "",
    residential_address: "",
    source: "",
    occupation: "",
    //birth_year_only: "",
    hk_id: ""
}

export const updateLocalWorkerOfInvoiceFormState = {
    name: "",
    surname: "",
    maiden_surname: "",
    alias_name: "",
    country_code: "",
    mobile_number: "",
    whatsapp_country_code: "",
    whatsapp_number: "",
    email: "",
    home_country_code: "",
    home_phone_number: "",
    nationality: "",
    hk_id: "",
    wait_in_macau: "",
    early_release_date: "",
    visa_expiry_date: "",
    contract_end_date: "",
    contract_category: "",
    contract_status: "",
    expect_released_early: "",
}

export const workerBasicProfileUpdate = {
    name: "",
    surname: "",
    maiden_surname: "",
    alias_name: "",
    country_code: "",
    mobile_number: "",
    whatsapp_country_code: "",
    whatsapp_number: "",
    email: "",
    home_country_code: "",
    home_phone_number: "",
    nationality: "",
    hk_id: "",
    contract_category: "",
}

export const updateGeneralLocalWorkerOfInvoiceFormState = {

    name: "",
    surname: "",
    country_code: "",
    mobile_number: "",
    hk_id: "",
    date_of_birth: "",
    passport_number: "",
    country_code_name: "",

    // name: "",
    // surname: "",
    // maiden_surname: "",
    // alias_name: "",
    // country_code: "",
    // mobile_number: "",
    // whatsapp_country_code: "",
    // whatsapp_number: "",
    // email: "",
    // home_country_code: "",
    // home_phone_number: "",
    // country_code_name: "",
    // whatsapp_country_code_name: "",
    // date_of_birth: "",
    // passport_number: "",
    // mobile_verified: 0,
    // whatsapp_verified: 0,
    // whatsapp_verified_at:null,
    // nationality: "",
    // hk_id: "",
    // contract_category: "",
    // wait_in_macau: "",
    // early_release_date: "",
    // visa_expiry_date: "",
    // contract_end_date: "",
    // contract_status: "",
    // expect_released_early: "",
}

export const updateLocalWorkerOfInsuranceFormState = {
    name: "",
    surname: "",
    country_code: "",
    mobile_number: "",
    hk_id: "",
    date_of_birth: "",
    passport_number: "",
    country_code_name: "",
    // maiden_surname: "",
    // alias_name: "",
    // country_code: "",
    // mobile_number: "",
    // whatsapp_country_code: "",
    // whatsapp_number: "",
    // email: "",
    // home_country_code: "",
    // home_phone_number: "",
    // nationality: "",
    // hk_id: "",
    // contract_category: "",
    // wait_in_macau: "",
    // early_release_date: "",
    // visa_expiry_date: "",
    // contract_end_date: "",
    // contract_status: "",
    // expect_released_early: "",
}

export const addWorkerFormState = {
    name: "",
    surname: "",
    country_code: "",
    mobile_number: "",
    hk_id: "",
    date_of_birth: "",
    passport_number: "",
    country_code_name: "",
}

export const updateOverseasWorkerOfInvoiceFormState = {
    name: "",
    surname: "",
    maiden_surname: "",
    alias_name: "",
    country_code: "",
    mobile_number: "",
    whatsapp_country_code: "",
    whatsapp_number: "",
    email: "",
    home_country_code: "",
    home_phone_number: "",
    nationality: "",
    hk_id: "",
    contract_category: ""
}

export const updateGeneralOverseasWorkerOfInvoiceFormState = {
    name: "",
    surname: "",
    country_code: "",
    mobile_number: "",
    hk_id: "",
    date_of_birth: "",
    passport_number: "",
    country_code_name: "",
    // name: "",
    // surname: "",
    // maiden_surname: "",
    // alias_name: "",
    // country_code: "",
    // mobile_number: "",
    // whatsapp_country_code: "",
    // whatsapp_number: "",
    // // email: "",
    // home_country_code: "",
    // home_phone_number: "",
    // country_code_name: "",
    // whatsapp_country_code_name: "",
    // mobile_verified: 0,
    // whatsapp_verified: 0,
    // whatsapp_verified_at: null,
    // nationality: "",
    //hk_id: "",
    // contract_category: ""
}
export const updateOverseasWorkerOfInsuranceFormState = {
    name: "",
    surname: "",
    country_code: "",
    mobile_number: "",
    hk_id: "",
    date_of_birth: "",
    passport_number: "",
    country_code_name: "",
    // name: "",
    // surname: "",
    // maiden_surname: "",
    // alias_name: "",
    // country_code: "",
    // mobile_number: "",
    // whatsapp_country_code: "",
    // whatsapp_number: "",
    // email: "",
    // home_country_code: "",
    // home_phone_number: "",
    // nationality: "",
    // hk_id: "",
    // contract_category: ""
}
export const updateEmployerFormState = {
    employer_id: null,
    title: "",
    name: "",
    surname: "",
    chinese_name: "",
    country_code: "",
    mobile_number: "",
    gender: "",
    whatsapp_country_code: "",
    whatsapp_number: "",
    email: "",
    spoken_language: "",
    nationality: "",
    district: "",
    location: "",
    branch_id: null,
    birth_date: '',
    hk_id: '',
    residential_address_id: 1,
    residential_address_line_1: "",
    correspondence_address_id: "",
    correspondence_address_line_1: "",
    current_worker: []
}

export const instantInterviewFormState = {
    status: 6,
    type: "update_original",
    comment: "",
}

export const addJOFormState = {
    start_date: new Date().toISOString().split('T')[0],
    asap: 0,
    flexible_start_date: '',
    role_id: '',
    spoken_language: [],
    helper_nationality: [],
    current_location: [],
    overseas_exp: '',
    contract_status: '',
    skills: [],
    priorities_ranking: [],
    responsibilities: [],
    cooking: [],
    special_course: [],
    education: "",
    employer_nationality: "",
    employer_location: "",
    employer_district: "",
    employer_house_size: "",
    helper_accommadation: "",
    day_off: "",
    coworker_status: 0,
    expected_salary: '',
    min_salary: 0,
    max_salary: 0,
    fixed_salary: 0,
    higher_salary: "",
    salary_bonus: "",
    detailed_description: "",
    adults_are_working: '',
    religion: [0],
    having_siblings: 'null',
    marital_status: '0',
    having_children: 'null',
    min_age: 21,
    max_age: 45,
    head_line: '',
    job_description_english: '',
    indonesian_head_line: '',
    indonesian_job_description: '',
    adult_count: 0,
    adult_count_info: [],
    baby_count: 0,
    baby_count_info: [],
    expecting_baby_count: 0,
    expecting_baby_count_info: [],
    child_count: 0,
    child_count_info: [],
    elderly_count: 0,
    elderly_count_info: [],
    pet_count_info: [],
}

export const workerBioProfileState = {
    current_location: "",
    earliest_can_start_date: "",
    contract_status: "",
    age: "",
    contract_end_date: null,
    contract_can_start_date: null,
    open_to_working_in: [],
    job_status: "",
    role: "",
    gender: "",
    nationality: "",
    religion: "",
    height: "",
    weight: 0,
    date_of_birth: null,
    spoken_language: [],
    marital_status: "",
    oldest_child_age: 0,
    children_count: 0,
    siblings_count: 0,
    //language: [],
    special_course: [],
    education: "",
    college_name: "",
    college_study: "",
    skills: [],
    cooking: [],
    care_newborn: 0,
    day_off: "",
    care_disability: 0,
    interview_day: [],
    share_work: 0,
    reference_letter: 0,
    share_room: 0,
    additional_info: "",
    work_experience: 0,
    care_elderly: 0,
    visa_expiry_date: "",
    expect_released_early: "0",
    early_release_date: "",
    age_of_elder: null,
    child_care_age_ids: [],
    terminated_reason: ""
}

export const workerExperienceState =
{
    id: "",
    worker_role: "",
    spoken_language: [],
    work_country_id: "",
    end_date: "",
    domestic_experience: "",
    employer_nationality: "",
    start_date: "",
    family_size: "",
    house_size: "",
    district_id: "",
    leaving_reason: "",
    cooking: [],
    main_duties: []
}

export const addUpdateWorkerBioState = {
    start_date: new Date().toISOString().split('T')[0]
}

export const saveWorkerBasicProfileState = {
    surname: "",
    name: "",
    chinese_name: "",
    maiden_surname: "",
    alias_name: "",
    marital_status: "",
    hk_id: "",
    nationality: "",
    date_of_birth: "",
    birth_place: "",
    origin_place: "",
    occupation: "",
    primary_present_address: "",
    primary_domicile_address: "",
    current_employer_name: "",
    current_employer_address_line_1: "",
    worker_employer: []
}

export const editProfileState = {
    title: "",
    chinese_name: "",
    name: "",
    surname: "",
    country_code: "",
    whatsapp_number: "",
    whatsapp_country_code: "",
    mobile_number: "",
    alternate_mobile_country_code: "",
    alternate_mobile_number: "",
    email: "",
}

export const saveWorkerConsulateState = {
    sss_number: "",
    phill_health_number: "",
    pag_ibig_number: "",
    beneficiary_name: "",
    beneficiary_contact: "",
    beneficiary_address: "",
    relationship_with_worker: ""
}


export const saveWorkerConsulateStateIndo = {
    ktp: "",
    nama_suami: "",
    nama_ayah: "",
    nama_ibu: ""
}

export const workerUploadPassportState = {
    passport_number: "",
    passport_place_of_issue: "",
    passport_issue_date: "",
    passport_expiry_date: ""
}

export const saveWorkerPassportDocUploadState = {
    name_in_passport: "",
    birth_date_in_passport: "",
    birth_place_in_passport: "",
    passport_number: "",
    passport_issue_date: "",
    passport_expiry_date: ""
}

export const saveWorkerIndoIdDocUploadState = {
    name_in_indonesian_id: "",
    birth_date_in_indonesian_id: "",
    birth_place_in_indonesian_id: "",
}

export const saveWorkerBirthDocUploadState = {
    name_in_birth_certificate: "",
    birth_date_in_birth_certificate: "",
    birth_place_in_birth_certificate: "",
}

export const saveWorkerFamilyCertificateDocUploadState = {
    name_in_family_certificate: "",
    birth_date_in_family_certificate: "",
    birth_place_in_family_certificate: "",
}

export const saveWorkerEducationCertificateDocUploadState = {
    name_in_education_certificate: "",
    birth_date_in_education_certificate: "",
    birth_place_in_education_certificate: "",
}

export const addWorkerBioDataFormState = {
    role: '1',
    name: "",
    surname: "",
    country_code: "",
    mobile_number: "",
    whatsapp_country_code: "",
    whatsapp_number: "",
    email: "",
    worked_abroad: '',
    worked_in: [],
    // nationality: '',
    earliest_can_start_date: '',
    date_of_birth: "",
    height: '',
    weight: '',
    religion: '',
    gender: '',
    marital_status: '',
    siblings_count: 0,
    children_count: 0,
    oldest_child_age: '',
    work_experience: '',
    college_name: "",
    college_study: "",
    education: '',
    special_course: [],
    spoken_language: [],
    skills: [],
    child_care_age_ids: [],
    cooking: [],
    experience: [
        {
            main_duties: [],
            contract_status: '',
            district_id: '',
            house_size: '',
            family_size: '',
            employer_nationality: '',
            end_date: '',
            start_date: '',
            work_country_id: '1',
            spoken_language: [],
            worker_role: '1',
            leaving_reason: '',
            action: 'add'
        }
    ],
    care_newborn: '',
    care_disability: '',
    care_elderly: '',
    share_room: '',
    share_work: '',
    day_off: '',
    interview_day: [],
    reference_letter: '',
    reference_letter_file: "",
    device_type: getDeviceType()?.id,
    branch_id: '',
};
export const partnerPassportFormState = {
    passport_number: "",
    passport_place_of_issue: "",
    passport_issue_date: '',
    passport_expiry_date: '',
    passport_main_page: "",
    passport_sign_page: ""
}
export const partnerProcessingFormState = {
    hk_id: "",
    birth_place: "",
    origin_place: "",
    present_address: "",
    domicile_address: ""
}
export const eVisaFormState = {
    visa_reference_no: "",
    e_visa_payment_date: null,
    ac_refunded: "1",
}
export const processingDHLContractForm = {
    sent_on: null,
    sim_card_number: "",
    current_location_code: "",
}
export const procssingFlightDetailsForm = {
    booking_made_by: "partner",
    flight_number: "",
    from_place: "",
    to_place: "",
    departure_date: null,
    departure_time: null,
    arrival_date: null,
    arrival_time: null,
}
export const processingHKIDForm = {
    schedule_hkid_appointment: "y",
    hkid_requested_date: null,
    hkid_arrival_date: null,
    branch_id: "",
    other_branch: "other",
}
export const processingPickUpForm = {
    require_pickup: "y",
    send_er_reminder_prior_72_days: false,
    send_er_reminder_prior_24_days: false
}
export const processingFollowUpFormState = {
    templateName: '',
    followUpNotes: '',
    date: '',
    time: ''
}
export const id988bFormState = {
    employer_chinese_name: "",
    employer_surname: "",
    employer_name: "",
    employer_gender: "",
    employer_birth_date: "",
    employer_hk_id: "",
    employer_hk_id_check: "Yes",
    employer_nationality: "",
    employer_occupation: "",
    employer_travel_document_type: "",
    employer_travel_document_number: "",
    employer_default_residential_address: "",
    employer_default_correspondence_address: "",
    employer_day_time_contact_telephone_number: "",
    employer_contact_telephone_ext: "",
    employer_fax_number: "",
    employer_home_telephone_number: "",
    employer_contact_email: "",
    worker_name: "",
    helper_application_reference_no: "",
    relationship_with_helper: "",
    helper_contact_telephone_number: "",
    helper_contact_telephone_number_ext: "",
    helper_fax_number: "",
    employment_of_the_helper: "",
    name_of_helper_being_replaced: "",
    hk_id_of_helper_being_replaced: "",
    contract_termination_date: "",
    leave_arrangement: "",
    worker_mututaly_agreed_defer_leave_reason: "",
    employer_monthly_household_check: "yes",
    employer_monthly_household: "",
    employer_bedroom_no: "",
    separate_servant_room: "",
    family_members: [],
    current_helpers: [],
    worker_origin_place: "",
    contract_number: "",
}

const populateWorkerAddresses = (formData) => {
    let addresses = [];

    if (formData?.worker_present_address) {
        if (Array.isArray(formData.worker_present_address)) {
            // If array → push all items
            addresses.push(
                ...formData.worker_present_address.map(e => ({
                    ...e,
                    type: 1
                }))
            );
        } else if (typeof formData.worker_present_address === "string" && formData.worker_present_address.trim() !== "") {
            // If string → push single object
            addresses.push({
                id: 0,
                address: formData.worker_present_address,
                type: 1,
                default: 1
            });
        }
    }

    if (formData?.worker_domicile_address) {
        if (Array.isArray(formData.worker_domicile_address)) {
            addresses.push(
                ...formData.worker_domicile_address.map(e => ({
                    ...e,
                    type: 2
                }))
            );
        } else if (typeof formData.worker_domicile_address === "string" && formData.worker_domicile_address.trim() !== "") {
            addresses.push({
                id: 0,
                address: formData.worker_domicile_address,
                type: 2,
                default: 0
            });
        }
    }

    return addresses;
};


export const masterFormData = (formData) => {
    const md = formData?.master_form_details || {};
    const worker = formData?.worker || {};
    const employer =
        formData?.employer && typeof formData.employer === "object" && !formData.employer.error
            ? formData.employer
            : {};

    return {
        // Worker Personal Details
        worker_name: worker?.name || "",
        worker_surname: worker?.surname || "",
        worker_maiden_surname: worker?.maiden_surname || "",
        worker_chinese_name: worker?.chinese_name || "",
        worker_alias_name: worker?.alias_name || "",
        worker_gender: (worker?.gender ?? "").toString() || "",
        worker_date_of_birth: worker?.date_of_birth || "",
        worker_birth_place: worker?.birth_place || "",
        worker_origin_place: worker?.origin_place || "",
        worker_marital_status: (worker?.marital_status ?? "").toString() || "",
        worker_occupation: worker?.occupation || "",
        worker_nationality: worker?.nationality || "",
        worker_hk_id: worker?.hk_id || "",

        // Worker Document Details
        worker_passport_number: worker?.passport_number || "",
        worker_passport_place_of_issue: worker?.passport_place_of_issue || "",
        worker_passport_issue_date: worker?.passport_issue_date || "",
        worker_passport_expiry_date: worker?.passport_expiry_date || "",

        // Combined worker addresses (present first then domicile)
        worker_addresses:
            (formData?.worker_present_address || formData?.worker_domicile_address)
                ? populateWorkerAddresses(formData)
                : [{ id: 0, address: "", type: 1, default: 1 }],


        // Worker Employment Status (from master_form_details)
        worker_current_status_in_hongkong: md?.worker_current_status_in_hongkong || "",
        worker_current_status_other_text: md?.worker_current_status_other_text || "",
        worker_permit_date_in_hong_kong: md?.worker_permit_date_in_hong_kong || "",
        worker_purpose_of_application: md?.worker_purpose_of_application || "deferring_home_leave",
        worker_purpose_of_application_date: md?.worker_purpose_of_application_date || "",
        worker_refused_visa: md?.worker_refused_visa ?? "n",
        worker_refused_visa_details: md?.worker_refused_visa_details || "",

        // Worker Current Employment
        worker_current_employer_name: worker?.current_employer_name || "",
        worker_current_employer_address_line_1: worker?.current_employer_address_line_1 || "",
        worker_work_experience: worker?.work_experience ?? 0,
        worker_work_experience_in_months: worker?.work_experience_in_months ?? 0,

        // Employer Personal Details
        employer_name: employer?.name || "",
        employer_surname: employer?.surname || "",
        employer_maiden_surname: employer?.maiden_surname || "",
        employer_chinese_name: employer?.chinese_name || "",
        employer_gender: (employer?.gender ?? "").toString() || "",
        employer_birth_date: employer?.birth_date || "",
        employer_hk_id: employer?.hk_id || "",
        employer_nationality: employer?.nationality ?? "",
        employer_occupation: employer?.occupation || "",

        // Employer Document Details
        employer_travel_document_type: employer?.travel_document_type || "",
        employer_travel_document_number: employer?.travel_document_number || "",

        // Employer Address Details (payload uses residential_address/correspondence_address)
        employer_residential_address: formData?.employer_residential_address ?? employer?.residential_address ?? "",
        employer_correspondence_address: formData?.employer_correspondence_address ?? employer?.correspondence_address ?? "",

        // Employer Contact Info (prefer explicit contact_telephone_number, else home_telephone_number)
        employer_home_telephone_number:
            (employer?.home_telephone_number ?? employer?.contact_telephone_number ?? "")?.toString() || "",
        employer_fax_number: employer?.fax_number || "",
        employer_day_time_contact_telephone_number: employer?.home_telephone_number || "",
        employer_contact_telephone_ext: employer?.contact_telephone_ext || "",
        employer_contact_email: employer?.contact_email || "", // worker contact_email present in payload
        employer_specify: "",

        // Household Details (some values exist under employer in your payload)
        employer_bedroom_no: employer?.bedroom_no ?? md?.bedroom_no ?? 0,
        employer_monthly_household: employer?.monthly_household ?? md?.monthly_household ?? 0,
        employer_adult_count: employer?.adult_count ?? 0,
        employer_child_age_5_8_count: employer?.child_age_5_8_count ?? 0,
        employer_child_age_below_5_count: employer?.child_age_below_5_count ?? 0,
        employer_expecting_baby_count: employer?.expecting_baby_count ?? 0,
        employer_special_needs_count: employer?.special_needs_count ?? 0,

        employer_no_of_helpers_to_serve_houseold: employer?.no_of_helpers_to_serve_houseold || 0,
        employer_family: formData?.employer_family || [],
        employer_workers: formData?.employer_workers || [],

        //Contract
        contract_number: md?.contract_number || "",
        worker_contract_date: md?.worker_contract_date || "",
        employer_contract_date: md?.employer_contract_date || "",
        employer_witness: md?.employer_witness || "",
        worker_witness: md?.worker_witness || "",
        wage: md?.wage,
        food_allowence: md?.food_allowence,
        other_fees: md?.other_fees,
        employer_house_size: employer?.house_size,

        // Accommodation Details
        separate_servant_room: employer?.separate_servant_room ?? md?.separate_servant_room ?? "y",
        independent_room: "y",
        share_room_with_children_age: employer?.share_room_with_child_age || 0,
        number_of_children: employer?.child_age_below_5_count ?? 0,
        share_room_with_child_age: md?.share_room_with_child_age || "",
        estimated_size_of_the_servant_room: md?.estimated_size_of_the_servant_room || "",
        // separate_partition_size: 0,

        // Accommodation Facilities (defaults)
        light_and_water_supply: md?.light_and_water_supply?.toString() || "",
        toilet_and_bath_facilities: md?.toilet_and_bathing_facilities?.toString() || "",
        bed: md?.bed?.toString() || "",
        blankets_or_quilt: md?.blankets_or_quilt?.toString() || "",
        pillows: md?.pillows?.toString() || "",
        wardrobe: md?.wardrobe?.toString() || "",
        refrigerator: md?.refrigerator?.toString() || "",
        desk: md?.desk?.toString() || "",
        other_facilities_please_specify: md?.other_facilities_please_specify || '',
        // other_facilities_checkbox: "0",

        // Worker Application Details (from master_form_details)
        // contract_number: Number(md?.contract_number) || "",
        relationship_with_helper: md?.relationship_with_helper || "",
        employment_of_the_helper: md?.employment_of_the_helper || "first_time",
        name_of_helper_being_replaced: md?.name_of_helper_being_replaced || "",
        hk_id_of_helper_being_replaced: md?.hk_id_of_helper_being_replaced ?? null,
        contract_termination_date: md?.contract_termination_date || "",
        entry_visa: md?.entry_visa || "take_up_employment",

        worker_employers: formData?.worker_employers || [],

        // Additional Requirements
        other_duties: md?.other_duties || "",

        // Conviction info from master_form_details
        convicted_of_any_crime: md?.convicted_of_any_crime ?? null,
        convicted_of_any_crime_details: md?.convicted_of_any_crime_details ?? null,
        last_saved_at: formData?.last_saved_at || {},
    };
};

export const id988aFormData = (formData) => {
    const { worker, employer, master_form_details, worker_employers } = formData || {};

    return {
        // Application Type - FIXED: Use proper values from master_form_details
        entry_visa: master_form_details?.entry_visa || "take_up_employment",
        worker_purpose_of_application: master_form_details?.worker_purpose_of_application || "deferring_home_leave",

        // Personal Particulars
        worker_surname: worker?.surname || "",
        worker_name: worker?.name || "",
        worker_maiden_surname: worker?.maiden_surname || "",
        worker_chinese_name: worker?.chinese_name || "",
        worker_alias_name: worker?.alias_name || "",
        worker_gender: worker?.gender?.toString() || "1",
        worker_date_of_birth: worker?.date_of_birth || "",
        worker_birth_place: worker?.birth_place || "",
        worker_marital_status: worker?.marital_status?.toString() || "1",
        worker_hk_id: worker?.hk_id || "",
        worker_change_name: worker?.change_name || "",
        worker_change_name_option: worker?.change_name ? 'yes' : 'no',
        worker_nationality: worker?.nationality?.toString() || "",
        worker_occupation: worker?.occupation || "Helper",

        // Travel Document
        worker_passport_number: worker?.passport_number || "",
        worker_passport_place_of_issue: worker?.passport_place_of_issue || "",
        worker_passport_issue_date: worker?.passport_issue_date || "",
        worker_passport_expiry_date: worker?.passport_expiry_date || "",


        worker_addresses:
            (Array.isArray(formData?.worker_present_address) && formData.worker_present_address.length > 0) ||
                (Array.isArray(formData?.worker_domicile_address) && formData.worker_domicile_address.length > 0)
                ? populateWorkerAddresses(formData)
                : [{ id: 0, address: "", type: 1, default: 1 }],

        // Contact Info - FIXED: Changed to worker contact fields
        employer_day_time_contact_telephone_number: employer?.home_telephone_number || "",
        employer_contact_telephone_ext: employer?.contact_telephone_ext || "",
        employer_fax_number: employer?.fax_number || "",
        employer_contact_email: employer?.contact_email || "",

        worker_contact_telephone_number: worker?.contact_telephone_number || "",
        worker_contact_telephone_ext: worker?.contact_telephone_ext || "",
        worker_fax_number: worker?.fax_number || "",
        worker_contact_email: worker?.contact_email || "",

        // Current Employment
        worker_current_employer_name: worker?.current_employer_name || "",
        worker_current_employer_address_line_1: worker?.current_employer_address_line_1 || "",

        // Work Experience
        worker_work_experience: worker?.work_experience?.toString() || "0",
        worker_work_experience_in_months: worker?.work_experience_in_months?.toString() || "0",
        worker_employers: worker_employers?.map(emp => ({
            id: emp.id || 0,
            employer_name: emp.employer_name || "",
            employer_address: emp.employer_address || "",
            start_date: emp.start_date || "",
            end_date: emp.end_date || "",
            action: "add"
        })) || [],

        // Extension of Stay - FIXED: Use master_form_details
        worker_current_status_in_hongkong: master_form_details?.worker_current_status_in_hongkong || "",
        worker_current_status_other_text: master_form_details?.worker_current_status_other_text || "",
        worker_permit_date_in_hong_kong: master_form_details?.worker_permit_date_in_hong_kong || "",
        worker_purpose_of_application_date: master_form_details?.worker_purpose_of_application_date || "",

        // Declaration
        worker_refused_visa: master_form_details?.worker_refused_visa || "n",
        worker_refused_visa_details: master_form_details?.worker_refused_visa_details || "",
        convicted_of_any_crime: master_form_details?.convicted_of_any_crime || "n",
        convicted_of_any_crime_details: master_form_details?.convicted_of_any_crime_details || "",

        // Form-only fields (not in API)
        understand_liability: "yes",
        other_duties: master_form_details?.other_duties || "",
        name_changed: "no",
        previous_names: "",

    };
};

export const id988bFormData = (formData) => {
    const { worker, employer, employer_family, employer_workers, master_form_details } = formData || {};

    return {
        // Employer details
        employer_chinese_name: employer?.chinese_name || "",
        employer_surname: employer?.surname || "",
        employer_name: employer?.name || "",
        employer_gender: employer?.gender || "",
        employer_birth_date: employer?.birth_date || "",
        employer_hk_id: employer?.hk_id || "",
        employer_hk_id_check: "Yes",
        employer_nationality: employer?.nationality || "",
        employer_occupation: employer?.occupation || "",
        employer_travel_document_type: employer?.travel_document_type || "",
        employer_travel_document_number: employer?.travel_document_number || "",
        employer_default_residential_address: employer?.residential_address || "",
        employer_default_correspondence_address: employer?.correspondence_address || "",
        employer_day_time_contact_telephone_number: employer?.contact_telephone_number || "",
        employer_contact_telephone_ext: employer?.contact_telephone_ext || "",
        employer_fax_number: employer?.fax_number || "",
        employer_home_telephone_number: employer?.home_telephone_number || "",
        employer_contact_email: employer?.contact_email || "",
        employer_monthly_household_check: master_form_details?.monthly_household_check || "yes",
        employer_monthly_household: employer?.monthly_household || "",
        employer_bedroom_no: employer?.bedroom_no || "",
        employer_separate_servant_room: employer?.separate_servant_room || "",

        // Worker (helper) details
        worker_name: worker?.name || "",
        helper_application_reference_no: master_form_details?.helper_application_reference_no || "",
        relationship_with_helper: master_form_details?.relationship_with_helper || "",
        worker_contact_telephone_number: worker?.helper_contact_telephone_number || "",
        worker_contact_telephone_number_ext: worker?.helper_contact_telephone_number_ext || "",
        worker_contact_email: worker?.contact_email || "",
        worker_fax_number: worker?.fax_number || "",
        employment_of_the_helper: master_form_details?.employment_of_the_helper || "",
        name_of_helper_being_replaced: master_form_details?.name_of_helper_being_replaced || "",
        hk_id_of_helper_being_replaced: master_form_details?.hk_id_of_helper_being_replaced || "",
        contract_termination_date: master_form_details?.contract_termination_date || "",
        helper_leaving_terms: master_form_details?.helper_leaving_terms || "",
        mututaly_agreed_defer_leave_reason: master_form_details?.mututaly_agreed_defer_leave_reason || "",
        worker_origin_place: worker?.origin_place || "",
        contract_number: master_form_details?.contract_number || "",

        // Arrays
        family_members: (employer_family || []).map((f) => ({
            name: f.name || "",
            dob: f.dob || "",
            relationship: f.relationship || f.relation || "",
            hk_id: f.hk_id || "",
        })),

        current_helpers: (employer_workers || []).map((w) => ({
            worker_name: w.worker_name || w.name || "",
            hk_id: w.hk_id || "",
            staying_till_date_in_hk: w.staying_till_date_in_hk || "",
            employer_name: w.employer_name || "",
        })),
    };
};

export const iD407FormData = (formData) => {
    const { worker, employer, master_form_details, contract_id } = formData || {};

    return {
        // Contract details
        contract_id: contract_id || "",
        employer_name: employer?.name || "",
        worker_name: worker?.name || "",
        contract_creation_date: master_form_details?.contract_creation_date || "",
        contract_commencing_date: master_form_details?.contract_commencing_date || "",
        worker_origin_place: worker?.origin_place || "",
        contract_number: master_form_details?.contract_number || "",

        // Address and accommodation
        employer_residential_address: employer?.residential_address || "",
        employer_house_size: employer?.house_size?.toString() || "",
        employer_adult_count: employer?.adult_count?.toString() || "",
        employer_child_age_below_5_count: employer?.child_age_below_5_count?.toString() || "",
        employer_child_age_5_8_count: employer?.child_age_5_8_count?.toString() || "",
        employer_expecting_baby_count: employer?.expecting_baby_count?.toString() || "",
        special_needs_count: employer?.special_needs_count?.toString() || "",
        employer_no_of_helpers_to_serve_houseold: employer?.no_of_helpers_to_serve_houseold?.toString() || "",

        // Accommodation details
        employer_sleeping_arrangement_of_helper: employer?.sleeping_arrangement_of_helper || "n",
        employer_estimated_size_of_the_servant_room: employer?.estimated_size_of_the_servant_room?.toString() || "",
        employer_separate_partitionate_area_size: employer?.separate_partitionate_area_size?.toString() || "",

        employer_share_room_with_no_of_child: employer?.share_room_with_no_of_child?.toString() || "",
        employer_share_room_with_child_age: employer?.share_room_with_child_age?.toString() || "",

        employer_other_servant_room_details: master_form_details?.other_servant_room_details || "",

        // Wage and allowances
        wage: master_form_details?.wage?.toString() || "",
        food_allowence: master_form_details?.food_allowence?.toString() || "",

        // Facilities - FIXED: Convert to string "1"/"0" format
        light_and_water_supply: master_form_details?.light_and_water_supply?.toString() || "",
        toilet_and_bathing_facilities: master_form_details?.toilet_and_bathing_facilities?.toString() || "",
        bed: master_form_details?.bed?.toString() || "",
        blankets_or_quilt: master_form_details?.blankets_or_quilt?.toString() || "",
        pillows: master_form_details?.pillows?.toString() || "",
        wardrobe: master_form_details?.wardrobe?.toString() || "",
        refrigerator: master_form_details?.refrigerator?.toString() || "",
        desk: master_form_details?.desk?.toString() || "",
        other_facilities_please_specify: master_form_details?.other_facilities_please_specify || "",
    };
};

export const iD407FormState = {
    // Contract details
    contract_id: "",
    employer_name: "",
    worker_name: "",
    contract_creation_date: "",
    contract_commencing_date: "",
    worker_origin_place: "",
    contract_number: "",

    // Address and accommodation
    employer_residential_address: "",
    employer_house_size: "",
    employer_adult_count: "",
    employer_child_age_below_5_count: "",
    employer_child_age_5_8_count: "",
    employer_expecting_baby_count: "",
    special_needs_count: "",
    employer_no_of_helpers_to_serve_houseold: "",

    // Accommodation details
    employer_sleeping_arrangement_of_helper: "",
    employer_estimated_size_of_the_servant_room: "",
    // employer_estimated_size_of_the_servant_room_type: "",

    // Wage and allowances
    wage: "",
    food_allowence: "",

    // Facilities (convert to string for form compatibility)
    light_and_water_supply: "y",
    toilet_and_bathing_facilities: "y",
    bed: "y",
    blankets_or_quilt: "y",
    pillows: "y",
    wardrobe: "n",
    refrigerator: "n",
    desk: "y",
    other_facilities_please_specify: "",

    // Form-only fields (not in payload)
    accommodation_type: "", // Derived from employer_sleeping_arrangement_of_helper
    servant_room_size_unit: "square_feet",
    employer_residence_size_unit: "square_feet"
}

export const updateInsuranceFormState = {
    title: "",
    surname: "",
    name: "",
    chinese_name: "",
    email: "",
    mobile_number: "",
    country_code: "",
    employer_hk_id: "",
    birth_date: "",
    residential_address: "",
    worker_name: "",
    worker_code: "",
    worker_surname: "",
    passport_number: "",
    worker_hk_id: "",
    worker_date_of_birth: "",
    worker_country_code: "",
    worker_mobile_number: "",
    type: "",
    policy_id: "",
    invoice_number: "",
    previous_policy_number: "",
    policy_number: "",
    effective_date: "",
    expiry_date: "",
    worker_country_code_name: "",
    employer_country_code_name: "",
    employer_mobile_number_verified: 0,
    employer_email_verified: 0,
    worker_mobile_number_verified: 0,
    policy_name: "",
    invoice_id: "",
    worker_id: "",
    employer_id: "",
    additional_coverage_id: "",
    reference_number: "",
    coverage_effective_date: "",
    coverage_expiry_date: "",
    coverage_id: "",
    branch_id: "",
    staff_id: "",
}
export const followUpFormState = {
    title: "",
    description: "",
    follow_up_date: "",
    follow_up_time: ""
}